import Usuario from '../usuario/Usuario';
import Agenda from './Agenda';

export default class AgendaUsuario {
    public agendaId:number

    public agenda: Agenda;

    public usuarioId:string;

    public usuario:Usuario;

    public permiteCadastroHorarios: boolean;

    public permiteCadastroAgendamentos: boolean;

    public permiteCadastroBloqueios: boolean;

    public permiteCadastroFeriados: boolean;

    public permiteCadastroTipoConsulta: boolean;

    public permiteCadastroAvisos: boolean;

    public acessoLiberado: boolean;

    constructor() {
      this.agendaId = 0;
      this.agenda = new Agenda();
      this.usuarioId = '';
      this.usuario = new Usuario();
      this.permiteCadastroHorarios = false;
      this.permiteCadastroAgendamentos = false;
      this.permiteCadastroBloqueios = false;
      this.permiteCadastroFeriados = false;
      this.permiteCadastroTipoConsulta = false;
      this.permiteCadastroAvisos = false;
      this.acessoLiberado = false;
    }
}
